import {EditGuesser, CreateGuesser} from "@api-platform/admin";
import {
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    SelectInput,
    FormDataConsumer,
    useDataProvider,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { useState, useEffect } from 'react';

export const ValeurChampPersonnaliseEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="valeur" />
        </SimpleForm>
    </Edit>
);

const UtilisateurInput = () => {
    const dataProvider = useDataProvider();
    const champPersonnalise = useWatch({ name: 'champPersonnalise' });
    const [communauteId, setCommunauteId] = useState(null);
    
    useEffect(() => {
        if (champPersonnalise) {
            // Récupérer les détails du champ personnalisé pour obtenir la communauté
            dataProvider.getOne('champ_personnalises', { id: champPersonnalise })
                .then(({ data }) => {
                    if (data && data.communaute) {
                        setCommunauteId(data.communaute);
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération du champ personnalisé:', error);
                });
        }
    }, [champPersonnalise, dataProvider]);
    
    return (
        <FormDataConsumer>
            {({ formData }) => (
                <ReferenceInput 
                    source="utilisateur" 
                    reference="utilisateurs"
                    filter={communauteId ? { communaute: communauteId } : {}}
                >
                    <AutocompleteInput
                        optionText={(choice) =>
                            choice?.id
                                ? `${choice.email}`
                                : ''
                        }
                    />
                </ReferenceInput>
            )}
        </FormDataConsumer>
    );
};

export const ValeurChampPersonnaliseCreate = props => {
    let initialValues = {};
    
    return (
        <Create {...props}>
            <SimpleForm initialValues={initialValues}>
                <ReferenceInput source="champPersonnalise" reference="champ_personnalises">
                    <AutocompleteInput
                        optionText={(choice) =>
                            choice?.id
                                ? `${choice.nom}`
                                : ''
                        }
                    />
                </ReferenceInput>
                <UtilisateurInput />
                <TextInput source="valeur" />
            </SimpleForm>
        </Create>
    );
};
